import { TEXTS as ADS_TEXTS } from 'application/pages/AdsPage/renderer/texts';

export const TEXTS = {
  AUDIO_TITLE: 'Настройки аудиорекламы',
  VIDEO_TITLE: 'Настройки видеорекламы',
  CAMPAIGN_NAME_SECTION_TITLE: 'Название рекламной кампании',
  CAMPAIGN_NAME_LABEL: 'Введите название',
  CAMPAIGN_NAME_PLACEHOLDER: 'Например, РК 0004',
  CAMPAIGN_NAME_MAX_LENGTH_HINT: 'Максимум 128 символов',
  FORM_BLOCK_MODE_TITLE: ADS_TEXTS.FORM_BLOCK_MODE_TITLE,
  SELECT_MODE_TITLE: ADS_TEXTS.SELECT_MODE_TITLE,
  INPUT_MODE_INTERVAL_TITLE: ADS_TEXTS.INPUT_MODE_INTERVAL_TITLE,
  INPUT_MODE_PERIOD_TITLE: ADS_TEXTS.INPUT_MODE_PERIOD_TITLE,
  FORM_BLOCK_DATE_TITLE: ADS_TEXTS.FORM_BLOCK_DATE_TITLE,
  START_DATE: ADS_TEXTS.START_DATE,
  END_DATE: ADS_TEXTS.END_DATE,
  SWITCHER_INFINITELY_TITLE: ADS_TEXTS.SWITCHER_INFINITELY_TITLE,
  AD_TIMING_SETTING_TITLE: ADS_TEXTS.AD_TIMING_SETTING_TITLE,
  FORM_BLOCK_TIME_TITLE: ADS_TEXTS.FORM_BLOCK_TIME_TITLE,
  INPUT_START_TIME_TITLE: ADS_TEXTS.INPUT_START_TIME_TITLE,
  INPUT_END_TIME_TITLE: ADS_TEXTS.INPUT_END_TIME_TITLE,
  TAGS_LABEL: 'Теги',
  TAGS_PLACEHOLDER: 'Выберите или напишите новый тег',
  TAGS_OPEN_LABEL: 'Открыть список тегов',
  NEXT: 'Далее',
  BACK: 'Назад',
  INTERVAL_HINT_DESCRIPTION: 'Все ролики в рекламной кампании проигрываются по порядку с установленным интервалом.',
  INTERVAL_HINT_STEPS: ['Проигрывается первый ролик', 'Проходит интервал', 'Проигрывается следующий ролик в очереди'],
  AD_TYPE_EXACT_EXPLANATION: ADS_TEXTS.AD_TYPE_EXACT_EXPLANATION,
  AD_TYPE_PERIOD_EXPLANATION: ADS_TEXTS.AD_TYPE_PERIOD_EXPLANATION,
  AD_TYPE_INSTANT_EXPLANATION_TWO: ADS_TEXTS.AD_TYPE_INSTANT_EXPLANATION_TWO,
  INSTANT_LAUNCH_HINT:
    'Для запуска ролика переходите в раздел Адреса и нажмите на кнопку «Запустить моментальный ролик».',
  INSTANT_DEVICE_HINT:
    'Моментальный ролик доступен на всех типах устройств, кроме мобильного приложения и колонки SberBoom.',
};
